import { render, staticRenderFns } from "./contact-line.vue?vue&type=template&id=637f707c&scoped=true&"
import script from "./contact-line.vue?vue&type=script&lang=js&"
export * from "./contact-line.vue?vue&type=script&lang=js&"
import style0 from "./contact-line.vue?vue&type=style&index=0&id=637f707c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637f707c",
  null
  
)

export default component.exports